import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

// Create a baseQuery with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/communication`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Wrap the baseQuery with retry logic
const baseQueryWithRetry = retry(baseQuery, { maxRetries: 3 });

export const MessagesSlice = createApi({
  reducerPath: "messagesSlice",
  baseQuery: baseQueryWithRetry,
  tagTypes: ["messages"],
  endpoints: (builder) => ({
    // GET all chat users (conversations)
    getChatUsers: builder.query({
      query: () => "/chat-users",
      providesTags: ["messages"],
    }),

    // GET messages with specific user
    getMessages: builder.query({
      query: (otherUserId) => `/messages?other_user_id=${otherUserId}`,
      providesTags: ["messages"],
    }),

    // POST send a new message
    sendMessage: builder.mutation({
      query: (data) => ({
        url: "/store",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),

    // DELETE messages in bulk
    deleteMessages: builder.mutation({
      query: (data) => ({
        url: "/messages",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),

    // group related api calls

    // POST create new group
    createGroup: builder.mutation({
      query: (data) => ({
        url: "/group",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),

    getGroups: builder.query({
      query: () => "/groups",
      providesTags: ["messages"],
    }),

    deleteGroup: builder.mutation({
      query: (data) => ({
        url: "/group",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),
    // GET messages with specific user
    getGroupMessages: builder.query({
      query: (groupId) => `/group/messages?group_id=${groupId}`,
      providesTags: ["messages"],
    }),

    // POST send a new message
    sendGroupMessage: builder.mutation({
      query: (data) => ({
        url: "/group/message",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),

    leaveGroup: builder.mutation({
      query: (data) => ({
        url: "/group/leave",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),
    removeGroupMember: builder.mutation({
      query: (data) => ({
        url: "/group/remove-member",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),
    updateGroup: builder.mutation({
      query: (data) => ({
        url: "/group",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["messages"],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetChatUsersQuery,
  useGetMessagesQuery,
  useSendMessageMutation,
  useSendGroupMessageMutation,
  useDeleteMessagesMutation,
  useDeleteGroupMutation,
  useCreateGroupMutation,
  useGetGroupsQuery,
  useGetGroupMessagesQuery,
  useLeaveGroupMutation,
  useRemoveGroupMemberMutation,
  useUpdateGroupMutation,
} = MessagesSlice;
